import React, { createContext, useContext, PropsWithChildren } from 'react';
import {BridgeConfig, BridgeToken} from "../api/bridge";
import {useBridgeData} from "../hooks/useBridgeData";

export interface RhoAddressData {
  isLoading: boolean
  config?: BridgeConfig
  tokens: BridgeToken[];
}

const getInitialState = (): RhoAddressData => {
  return {
    isLoading: false,
    tokens: [],
  }
}

const initialState = getInitialState()
const UserDataContext = createContext(initialState);

export const useBridge = () => useContext(UserDataContext);

export const BridgeDataProvider: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { isLoading, tokens, config } = useBridgeData()

  return <UserDataContext.Provider value={{
    isLoading,
    config,
    tokens
  }}>
  {children}
  </UserDataContext.Provider>
};
